import { format } from "date-fns";
import React from "react";
import { BiFile } from "react-icons/bi";
import {
  BsCameraVideo,
  BsClock,
  BsFolderSymlink,
  BsUbuntu,
  BsUpload,
} from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import S from "../../Services/GeneralServices";
import { BaseUrl } from "../../api/basr_url";
import orgApi from "../../api/org_api";
import BarChart from "../../component/BarChart";
import { DashCard } from "../../component/Dashboard/CustomComponent";
import { CloseModal } from "../../component/Layout/CloseModal";
import SwitchComp from "../../component/Switch";
import { Button, Modal, Text } from "../../component/common";
import { getTz, greetings } from "../../utils/CommonMethods";
const emptyChart = require("../../assets/images/emptyChart.png");
const nodata = require("../../assets/images/nodata.png");

type DashboardProps = { notify: boolean; setLoading: Function };
const Dashboard: React.FC<DashboardProps> = ({
  setLoading,
}: DashboardProps): JSX.Element => {
  const org = JSON.parse(localStorage.getItem("user__details")?.toString()!);
  const [dashboard, setDashboard] = React.useState([]);
  const [fileError, setfileError] = React.useState("");
  const [uploadResumeModal, setUploadResumeModal] = React.useState(false);
  const [selectedResume, setselectedResume] = React.useState<File[]>([]);
  const [live, setLive] = React.useState([]);
  const [chart, setChart] = React.useState([]);
  const [scheduleProfile, setScheduleProfile] = React.useState(0);
  const [profile, setProfile] = React.useState([]);
  const [resumeType, setResumeType] = React.useState([] as any);
  const navigate = useNavigate();

  React.useEffect(() => {
    localStorage.setItem("jd_currentpage", "0");
    localStorage.setItem("jd_totalpage", "0");
    getDashboard();
    getLiveInterview();
  }, []);

  const getDashboard = async () => {
    setLoading(true);
    const res = await orgApi.dashSchedule(org.id);
    setDashboard(res.data.schedule);
    setLoading(false);
  };

  const getLiveInterview = async () => {
    setLoading(true);
    const res = await orgApi.dashLive(org.id);
    if (res.data.success) {
      setLive(res.data.live);
      setProfile(res.data.profile);
      const dates = [] as any;
      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      let currentDate = new Date();

      for (let i = 0; i < 7; i++) {
        const date = new Date(currentDate);
        dates.push({
          date: format(date, "dd MMM yyyy"),
          day: days[date.getDay()],
          schedule: 0,
        });
        currentDate.setDate(currentDate.getDate() + 1);
      }
      var p = 0;
      for (let index = 0; index < dates.length; index++) {
        var data1 = res.data.profile.filter((item: any) => {
          return format(item.date, "dd MMM yyyy") === dates[index]["date"];
        });
        if (data1.length !== 0) {
          dates[index]["schedule"] = Number(data1[0]["schedule"]);
          p = p + Number(data1[0]["schedule"]);
        }
      }
      setChart(dates);
      setScheduleProfile(p);
    }
    setLoading(false);
  };

  const openUploadResume = () => {
    setselectedResume([]);
    setUploadResumeModal(true);
  };

  const removeResume = async (index: number) => {
    setselectedResume((prevState) =>
      prevState.filter((_, ind) => ind !== index),
    );
    setResumeType((prevState: any) =>
      prevState.filter((_: any, ind: number) => ind !== index),
    );
  };

  const uploadResume = async () => {
    setUploadResumeModal(false);
    navigate("/job_description/", {
      state: { resumes: selectedResume, resumeType: resumeType },
    });
  };

  const handleResumeChange = async (event: any) => {
    const ds: any = await S.handleUploadResume(event.target.files);
    setfileError(ds["error"]);
    setselectedResume(ds["resumefiles"]);
    setResumeType(ds["resumeType"]);
  };

  const connect = (
    id: any,
    sid: any,
    job_title: any,
    schedule: any,
    jdDetail: any,
  ) => {
    let userInfo = JSON.parse(
      localStorage.getItem("user__details")?.toString()!,
    );
    localStorage.setItem("organization", userInfo.org_name);
    localStorage.setItem("org_data", JSON.stringify(userInfo));
    localStorage.setItem("job_title", job_title);
    localStorage.setItem("jd", JSON.stringify(jdDetail));
    localStorage.setItem("schedule", JSON.stringify(schedule));
    localStorage.setItem("channel", id);
    localStorage.setItem("type", "1");
    localStorage.setItem("sid", sid);
    localStorage.setItem("take_ss", "flase");
    localStorage.setItem(
      "name",
      userInfo.first_name + " " + userInfo.last_name,
    );
    localStorage.setItem("stType", "1");
    let str = BaseUrl.substr(BaseUrl.lastIndexOf("/") + 1);
    let url = BaseUrl.replace(new RegExp(str), "");
    window.open(url + "screenitMeeting/#/meeting");
  };

  const CARD_DATA = [
    {
      id: "1",
      text: "Job Description",
      content: org?.no_of_post,
    },
    {
      id: "2",
      text: "Interview",
      content: org?.completed,
    },
    {
      id: "3",
      text: "No Shows",
      content: org?.no_show,
      onClick: () => navigate("/interview_result/" + "no_show"),
    },
  ];

  return (
    <>
      <div className="h-[calc(100vh-95px)] 2xl:h-[calc(100vh-110px)] mt-1 overflow-y-auto">
        <div className="grid grid-cols-1 xl:grid-cols-4 gap-3 h-full ">
          <div className="xl:col-span-3 grid grid-cols-1  lg:grid-cols-3  gap-3 md:gap-3">
            {/* Greetings Section */}
            <div className="flex flex-col lg:col-span-2 justify-start items-start gap-1 p-2 md:p-0">
              <span className="text-xl md:text-2xl 2xl:text-3xl font-semibold text-black">
                {greetings()}!
              </span>
              <span className="text-xs md:text-sm 2xl:text-base font-normal text-gray-600">
                You can access all the stuff as you wish.
              </span>
            </div>
            {/* Action Buttons */}
            <div className=" lg:col-span-1 upload-buttons flex flex-col sm:flex-row gap-2 md:gap-3 w-full">
              <Button
                text="Quick Create"
                onClick={() => {
                  localStorage.removeItem("createPostId");
                  navigate("/upload_jd");
                }}
                leftIcon={BsUbuntu}
                className="h-fit"
              />
              <Button
                text="View JDs"
                onClick={() => navigate("/job_description")}
                leftIcon={BsFolderSymlink}
                variant="outlined"
                className="h-fit"
              />
              <Button
                text="Upload Candidate"
                onClick={() => openUploadResume()}
                leftIcon={BsUpload}
                variant="outlined"
                className="h-fit"
              />
            </div>
            {/* Dashboard Cards */}
            <div className="lg:col-span-3 grid  grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 ">
              {CARD_DATA.map((card) => (
                <DashCard
                  key={card.id}
                  Text={card.text}
                  Content={card.content}
                  OnClick={card?.onClick}
                />
              ))}
            </div>
            {/* Live Interview Section */}
            <div className="lg:col-span-1 row-span-1 h-[calc(100vh-260px)] 2xl:h-[calc(100vh-295px)] overflow-y-auto lg:row-span-2">
              <div className="bg-white border rounded-lg h-full ">
                <div className="p-4  sidebar-bg shadow rounded-lg h-full flex flex-col">
                  <div className="flex-1  overflow-y-auto flex flex-col">
                    <span className="mb-1 flex   items-center text-md 2xl:text-xl font-bold text-white">
                      <div className="inline-flex flex-shrink-0 items-center justify-center h-6 w-6  2xl:h-8 2xl:w-8 p-1 text-red-500  bg-white rounded-full mr-2">
                        <BsCameraVideo />
                      </div>
                      Live Interview
                    </span>
                    <div className="flex-1 h-[calc(100vh-200px)]  overflow-y-auto no-scrollbar">
                      {live.length === 0 ? (
                        <>
                          {[1, 2, 3, 4, 5].map((_, index) => (
                            <React.Fragment key={index}>
                              <li className="flex items-center border-b px-3 py-0 animate-pulse">
                                <div className="flex-grow flex items-center border-gray-100 text-sm text-gray-600 py-2">
                                  <div className="flex-grow justify-between items-center grid grid-cols-5">
                                    <div className="self-center col-span-3 truncate">
                                      <div className="font-medium text-xs md:text-sm 2xl:text-base text-gray-600 bg-gray-300 w-2/3 p-2 my-2 rounded">
                                        {"    "}
                                      </div>
                                      <div className="font-normal text-xs md:text-sm 2xl:text-base text-gray-300 bg-gray-300 w-2/3 p-1 my-2 rounded">
                                        {"    "}
                                      </div>
                                    </div>
                                    <div className="flex-shrink-0 ml-2 mr-1 col-span-2">
                                      <div className="flex items-center flex-col font-normal text-xs md:text-sm 2xl:text-base text-primary">
                                        <span className="bg-gray-300 w-2/3 p-2 my-1 rounded">
                                          {"    "}
                                        </span>
                                        <span className="bg-gray-300 w-2/3 p-1 my-1 rounded">
                                          {"    "}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </React.Fragment>
                          ))}
                        </>
                      ) : (
                        live.length > 0 &&
                        live.map((e: any, index: number) => (
                          <li
                            key={index}
                            className="flex items-center border-b p-1"
                          >
                            <div className="flex-grow flex items-center border-gray-100 text-sm text-gray-600 py-2">
                              <div className="flex-grow flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
                                <div className="flex flex-col gap-0.5">
                                  <Text
                                    className="text-white max-w-40 2xl:max-w-60 "
                                    text={e.candidate.first_name}
                                  />
                                  <Text
                                    className="text-gray-200 max-w-40 2xl:max-w-60"
                                    text={e.post.job_title}
                                  />
                                  <div className="flex items-center gap-1 text-gray-200 text-xs md:text-sm 2xl:text-base">
                                    <BsClock color="white" size={10} />
                                    <Text
                                      className="text-xs text-gray-200"
                                      text={`${format(
                                        e.utc_starttime,
                                        "hh:mm a",
                                      )} to ${" "}
                                        ${format(
                                          e.utc_endtime,
                                          "hh:mm a",
                                        )}${" "}
                                        ${getTz(e.candidate_tz)}`}
                                    />
                                  </div>
                                </div>
                                <Button
                                  text="Connect"
                                  variant="outlined"
                                  color="gray"
                                  className="text-white hover:bg-transparent hover:border-white"
                                  onClick={() => {
                                    connect(
                                      e.meeting_id,
                                      e.id,
                                      e.post.job_title,
                                      e,
                                      e.post,
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          </li>
                        ))
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Weekly Schedule Section */}
            <div className="lg:col-span-2 row-span-1 lg:row-span-2 h-full">
              <div className="bg-white border rounded-lg h-full">
                <div className="flex flex-col h-full">
                  <div className="flex items-center justify-between px-3 py-2 border-b">
                    <div>
                      <div className="text-md  2xl:text-xl font-semibold">
                        Schedules
                      </div>
                    </div>
                    <div className="flex items-center">
                      <div className="text-lg font-bold">{scheduleProfile}</div>
                    </div>
                  </div>
                  <div className="flex-1  ">
                    <section className="bg-transparent flex flex-col gap-2 font-DM-Sans h-full">
                      <div className="text-medium-brown bg-white rounded-lg md:rounded-xl p-3 md:p-4 h-full">
                        <div className="border-b-2  border-b-cream flex w-full items-end h-full">
                          {profile.length > 0 ? (
                            <div className="flex w-full justify-evenly">
                              <BarChart
                                chartData={chart}
                                schedulePage={(date: any) =>
                                  navigate("/signle_date_schedule/" + date)
                                }
                              />
                            </div>
                          ) : (
                            <div className="h-full w-full flex items-center justify-center">
                              <img
                                src={emptyChart}
                                className="h-auto max-h-[180px] w-full max-w-md object-contain px-4 py-3"
                                alt="empty-chart"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="border rounded-lg bg-white flex flex-col h-[calc(100vh-96px)] 2xl:h-[calc(100vh-110px)]">
            <div className="flex items-center justify-between border-b py-3 px-4 border-gray-100 flex-shrink-0">
              <div className="text-sm font-bold">Interview Result</div>
              <div
                className="text-xs mr-2 text-primary cursor-pointer hover:underline"
                onClick={() => navigate("/interview_result/" + "all")}
              >
                View All
              </div>
            </div>
            <div className="flex-1 overflow-y-auto">
              {dashboard && dashboard.length === 0 && (
                <>
                  {[1, 2, 3, 4, 5, 6].map((_, num_index) => (
                    <React.Fragment key={num_index}>
                      <li className="flex items-center border-b px-3 py-1 animate-pulse">
                        <div className="flex-grow flex items-center border-gray-100 text-sm text-gray-600 py-2">
                          <div className="col-span-1 flex-grow flex justify-between items-center grid grid-cols-5">
                            <div className="self-center col-span-3 truncate">
                              <div className="font-medium text-xs md:text-sm 2xl:text-base text-gray-600 bg-gray-200 w-2/3 p-2 my-2 rounded">
                                {"    "}
                              </div>
                              <div className="font-normal text-xs md:text-sm 2xl:text-base text-gray-300 bg-gray-200 w-2/3 p-1 my-2 rounded">
                                {"    "}
                              </div>
                            </div>
                            <div className="flex-shrink-0 ml-2 mr-1 col-span-2">
                              <div className="flex items-center flex-col font-normal text-xs md:text-sm 2xl:text-base text-primary">
                                <span className="bg-gray-200 w-2/3 p-2 my-1 rounded">
                                  {"    "}
                                </span>
                                <span className="bg-gray-200 w-2/3 p-1 my-1 rounded">
                                  {"    "}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </React.Fragment>
                  ))}
                </>
              )}
              <ul className="space-y-1 p-1">
                {dashboard &&
                  dashboard.length > 0 &&
                  dashboard.map((e: any, dash_index: number) => (
                    <li
                      className="flex items-center border-b p-3  hover:bg-gray-50 transition-colors"
                      key={dash_index}
                    >
                      <div className="self-center truncate flex-1">
                        <Text
                          className="text-xs 2xl:text-sm text-gray-700"
                          text={
                            e.candidate.first_name + " " + e.candidate.last_name
                          }
                        />
                        <Text
                          className="font-normal text-xs w-36 md:text-sm 2xl:text-base truncate text-gray-400"
                          text={e.post.job_title}
                        />
                      </div>
                      {S.getOrgDomain() !== "nam-it.com" ? (
                        <div
                          onClick={() => S.viewFeedback(e.id)}
                          className="flex items-center flex-col font-normal text-xs text-primary cursor-pointer hover:text-blue-700 transition-colors"
                        >
                          <Text text="SIT Score" />
                          <Text text={`${e.feedback[0].sit_score}/10`} />
                        </div>
                      ) : (
                        <Text
                          text="Feedback"
                          onClick={() => S.viewFeedback(e.id)}
                          className="flex items-center flex-col font-normal text-xs text-primary cursor-pointer hover:text-blue-700 transition-colors"
                        />
                      )}
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={uploadResumeModal}
        onClose={() => setUploadResumeModal(false)}
        title="Upload Resume"
        children={
          <div className="mt-2 border-t">
            <form className="max-w-lg mx-auto mt-2">
              <div className="flex items-center w-full border-primary rounded ">
                <div className="cursor-pointer w-full">
                  <label className="cursor-pointer w-full flex justify-start">
                    {selectedResume.length > 0 ? (
                      <div className="flex justify-center items-center border-r overflow-hidden font-semibold text-xs p-2 bg-primary text-white w-1/4">
                        <BsUpload color="white" size={10} /> &nbsp; Change
                      </div>
                    ) : (
                      <div className="flex justify-center items-center border-r  overflow-hidden font-semibold text-xs p-2 bg-primary text-white w-1/4">
                        <BsUpload color="white" size={10} /> &nbsp; Upload
                      </div>
                    )}
                    <div className="flex justify-start items-center w-2/4 ">
                      &nbsp;
                      {selectedResume.length !== 0 && (
                        <div className="text-sm px-3 text-gray-400 truncate">
                          {selectedResume[0]?.name}
                        </div>
                      )}
                      <input
                        type="file"
                        className="hidden"
                        multiple={true}
                        onChange={handleResumeChange}
                      ></input>
                    </div>
                  </label>
                </div>
              </div>
              {fileError && <div className="error mb-2">{fileError}</div>}
              <div className="mt-1 text-xs text-gray-500" id="user_avatar_help">
                {"Supported formats: .pdf, .docx; Maximum size: 3MB"}
              </div>
              <div className=" h-[calc(100vh-300px)] overflow-y-auto">
                {selectedResume && selectedResume.length > 0 ? (
                  selectedResume.map((resume: any, index: number) => (
                    <div
                      className="flex flex-row gap-2 justify-between my-2 p-1"
                      key={index}
                    >
                      <div className="flex items-center justify-center py-2 px-3 rounded-md text-blue-500 bg-blue-100">
                        <BiFile size={18} />
                      </div>
                      <div className="flex flex-col items-start  justify-start">
                        <Text
                          className="text-sm font-medium text-gray-600"
                          text={resume.name}
                        />
                        <SwitchComp
                          resumeType={resumeType}
                          setResumeType={setResumeType}
                          index={index}
                          on={"Auto"}
                          off={"Manual"}
                        ></SwitchComp>
                      </div>
                      <button
                        onClick={() => removeResume(index)}
                        type="button"
                        className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                      >
                        <CloseModal />
                      </button>
                    </div>
                  ))
                ) : (
                  <div className="flex flex-col h-full justify-center items-center gap-3 py-8">
                    <img
                      src={nodata}
                      alt="No resumes uploaded"
                      className="h-24 w-24 object-cover opacity-50"
                    />
                    <p className="text-sm text-gray-400">
                      No resumes uploaded yet.
                    </p>
                  </div>
                )}
              </div>
            </form>
            <div className=" gap-2 mt-3 sm:flex md:flex lg:flex flex-row-reverse">
              <button
                className={
                  selectedResume.length > 0
                    ? " button-primary mt-2 py-1 px-2.5 text-white outline-none text-sm rounded-md"
                    : " bg-indigo-300 mt-2 py-1 px-2.5 text-white outline-none text-sm rounded-md"
                }
                onClick={() => uploadResume()}
                disabled={selectedResume.length > 0 ? false : true}
              >
                Next
              </button>
              <button
                className=" mt-2 py-1 px-2.5 text-gray-800 outline-none border text-sm rounded-md"
                onClick={() => setUploadResumeModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        }
      />
    </>
  );
};
export default Dashboard;
